import { createRouter, createWebHistory } from "vue-router";
import { ReviseMeta } from "@/util/meta";
import { deviceType } from "@/util/base";

function createAdRoutes(platforms) {
  return platforms.flatMap(({ prefix, versions, componentMap }) =>
    versions.map((version) => ({
      path: `${prefix}-${version}`,
      name: `${prefix}-${version}`,
      component: () =>
        import(`./views/down/${componentMap[version] || version}.vue`),
    }))
  );
}

const adRoutesVersions = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "B2",
  "C2",
  "D2",
];

// 特殊映射
const adRoutesComponentMap = { L: "A", M: "F" };

// 广告路由 （/down）
const adRoutes = createAdRoutes([
  {
    prefix: "TT", // 抖音
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  },
  {
    prefix: "FB", // 脸书
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  },
  {
    prefix: "GG", // 谷歌
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  },
]);

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // 入口页面
    {
      path: "/",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title: "《人人有功練：腸仔江湖見》下載即送1750抽！",
        keywords:
          "人人有功練，腸仔江湖見，下載，抽獎武俠，江湖，豪俠，俠客，奇俠，無厘頭武俠，搞笑江湖，香腸仔，爆笑RPG，無厘頭遊戲，搞怪遊戲放置遊戲，放置掛機，放置卡牌，卡牌養成，卡牌RPG，角色扮演，輕鬆休閒，不肝不課，升級，戰力，逆襲，進化，養成，神器，掛機養成，多英雄對戰1750抽，免費送，抽獎，抽獎活動，無門檻福利遊戲，豪華獎勵，福利滿滿，開箱，無限開寶箱iPad Pro，LABUBU，Mycard點數卡，PS5，iPhone17 pro max，AirPods，超值大獎新武俠大明星，俠客傳説，暴走小蝦米, 吸血鬼幸存者, 鹹魚之王，一念逍遙，香腸三國，少年猛將傳，放置七騎士",
        description:
          "《人人有功練：腸仔江湖見》無厘頭武俠新解放置卡牌RPG 下載即送超癲1750抽，一起武林gogogo！",
      },
    },
    {
      path: "/m",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title: "《人人有功練：腸仔江湖見》下載即送1750抽！",
        keywords:
          "人人有功練，腸仔江湖見，下載，抽獎武俠，江湖，豪俠，俠客，奇俠，無厘頭武俠，搞笑江湖，香腸仔，爆笑RPG，無厘頭遊戲，搞怪遊戲放置遊戲，放置掛機，放置卡牌，卡牌養成，卡牌RPG，角色扮演，輕鬆休閒，不肝不課，升級，戰力，逆襲，進化，養成，神器，掛機養成，多英雄對戰1750抽，免費送，抽獎，抽獎活動，無門檻福利遊戲，豪華獎勵，福利滿滿，開箱，無限開寶箱iPad Pro，LABUBU，Mycard點數卡，PS5，iPhone17 pro max，AirPods，超值大獎新武俠大明星，俠客傳説，暴走小蝦米, 吸血鬼幸存者, 鹹魚之王，一念逍遙，香腸三國，少年猛將傳，放置七騎士",
        description:
          "《人人有功練：腸仔江湖見》無厘頭武俠新解放置卡牌RPG 下載即送超癲1750抽，一起武林gogogo！",
      },
    },
    // 预约页
    {
      path: "/pre",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "《人人有功練：腸仔江湖見》預約即送1750抽！",
        keywords:
          "人人有功練，腸仔江湖見，預約，抽獎，事前登錄武俠，江湖，豪俠，俠客，奇俠，無厘頭武俠，搞笑江湖，香腸仔，爆笑RPG，無厘頭遊戲，搞怪遊戲放置遊戲，放置掛機，放置卡牌，卡牌養成，卡牌RPG，角色扮演，輕鬆休閒，不肝不課，升級，戰力，逆襲，進化，養成，神器，掛機養成，多英雄對戰1750抽，免費送，預約就送，預約豪禮，預約好禮，抽獎，抽獎活動，無門檻福利遊戲，豪華獎勵，福利滿滿，開箱，無限開寶箱iPad Pro，LABUBU，Mycard點數卡，PS5，iPhone17 pro max，AirPods，超值大獎新武俠大明星，俠客傳説，暴走小蝦米, 吸血鬼幸存者, 鹹魚之王，一念逍遙，香腸三國，少年猛將傳，放置七騎士",
        description:
          "《人人有功練：腸仔江湖見》無厘頭武俠新解放置卡牌RPG 預約即送超癲1750抽，一起武林gogogo！還有傳說俠客免費拿！",
      },
    },
    {
      path: "/pre/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "《人人有功練：腸仔江湖見》預約即送1750抽！",
        keywords:
          "人人有功練，腸仔江湖見，預約，抽獎，事前登錄武俠，江湖，豪俠，俠客，奇俠，無厘頭武俠，搞笑江湖，香腸仔，爆笑RPG，無厘頭遊戲，搞怪遊戲放置遊戲，放置掛機，放置卡牌，卡牌養成，卡牌RPG，角色扮演，輕鬆休閒，不肝不課，升級，戰力，逆襲，進化，養成，神器，掛機養成，多英雄對戰1750抽，免費送，預約就送，預約豪禮，預約好禮，抽獎，抽獎活動，無門檻福利遊戲，豪華獎勵，福利滿滿，開箱，無限開寶箱iPad Pro，LABUBU，Mycard點數卡，PS5，iPhone17 pro max，AirPods，超值大獎新武俠大明星，俠客傳説，暴走小蝦米, 吸血鬼幸存者, 鹹魚之王，一念逍遙，香腸三國，少年猛將傳，放置七騎士",
        description:
          "《人人有功練：腸仔江湖見》無厘頭武俠新解放置卡牌RPG 預約即送超癲1750抽，一起武林gogogo！還有傳說俠客免費拿！",
      },
    },
    // 广告投放营销预约页FB-X渠道
    {
      path: "/pre/FB",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "《人人有功練：腸仔江湖見》預約即送1750抽！",
        keywords:
          "人人有功練，腸仔江湖見，預約，抽獎，事前登錄武俠，江湖，豪俠，俠客，奇俠，無厘頭武俠，搞笑江湖，香腸仔，爆笑RPG，無厘頭遊戲，搞怪遊戲放置遊戲，放置掛機，放置卡牌，卡牌養成，卡牌RPG，角色扮演，輕鬆休閒，不肝不課，升級，戰力，逆襲，進化，養成，神器，掛機養成，多英雄對戰1750抽，免費送，預約就送，預約豪禮，預約好禮，抽獎，抽獎活動，無門檻福利遊戲，豪華獎勵，福利滿滿，開箱，無限開寶箱iPad Pro，LABUBU，Mycard點數卡，PS5，iPhone17 pro max，AirPods，超值大獎新武俠大明星，俠客傳説，暴走小蝦米, 吸血鬼幸存者, 鹹魚之王，一念逍遙，香腸三國，少年猛將傳，放置七騎士",
        description:
          "《人人有功練：腸仔江湖見》無厘頭武俠新解放置卡牌RPG 預約即送超癲1750抽，一起武林gogogo！還有傳說俠客免費拿！",
      },
    },
    {
      path: "/pre/FB/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "《人人有功練：腸仔江湖見》預約即送1750抽！",
        keywords:
          "人人有功練，腸仔江湖見，預約，抽獎，事前登錄武俠，江湖，豪俠，俠客，奇俠，無厘頭武俠，搞笑江湖，香腸仔，爆笑RPG，無厘頭遊戲，搞怪遊戲放置遊戲，放置掛機，放置卡牌，卡牌養成，卡牌RPG，角色扮演，輕鬆休閒，不肝不課，升級，戰力，逆襲，進化，養成，神器，掛機養成，多英雄對戰1750抽，免費送，預約就送，預約豪禮，預約好禮，抽獎，抽獎活動，無門檻福利遊戲，豪華獎勵，福利滿滿，開箱，無限開寶箱iPad Pro，LABUBU，Mycard點數卡，PS5，iPhone17 pro max，AirPods，超值大獎新武俠大明星，俠客傳説，暴走小蝦米, 吸血鬼幸存者, 鹹魚之王，一念逍遙，香腸三國，少年猛將傳，放置七騎士",
        description:
          "《人人有功練：腸仔江湖見》無厘頭武俠新解放置卡牌RPG 預約即送超癲1750抽，一起武林gogogo！還有傳說俠客免費拿！",
      },
    },
    // 广告投放营销预约页GG-Y渠道
    {
      path: "/pre/GG",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "《人人有功練：腸仔江湖見》預約即送1750抽！",
        keywords:
          "人人有功練，腸仔江湖見，預約，抽獎，事前登錄武俠，江湖，豪俠，俠客，奇俠，無厘頭武俠，搞笑江湖，香腸仔，爆笑RPG，無厘頭遊戲，搞怪遊戲放置遊戲，放置掛機，放置卡牌，卡牌養成，卡牌RPG，角色扮演，輕鬆休閒，不肝不課，升級，戰力，逆襲，進化，養成，神器，掛機養成，多英雄對戰1750抽，免費送，預約就送，預約豪禮，預約好禮，抽獎，抽獎活動，無門檻福利遊戲，豪華獎勵，福利滿滿，開箱，無限開寶箱iPad Pro，LABUBU，Mycard點數卡，PS5，iPhone17 pro max，AirPods，超值大獎新武俠大明星，俠客傳説，暴走小蝦米, 吸血鬼幸存者, 鹹魚之王，一念逍遙，香腸三國，少年猛將傳，放置七騎士",
        description:
          "《人人有功練：腸仔江湖見》無厘頭武俠新解放置卡牌RPG 預約即送超癲1750抽，一起武林gogogo！還有傳說俠客免費拿！",
      },
    },
    {
      path: "/pre/GG/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "《人人有功練：腸仔江湖見》預約即送1750抽！",
        keywords:
          "人人有功練，腸仔江湖見，預約，抽獎，事前登錄武俠，江湖，豪俠，俠客，奇俠，無厘頭武俠，搞笑江湖，香腸仔，爆笑RPG，無厘頭遊戲，搞怪遊戲放置遊戲，放置掛機，放置卡牌，卡牌養成，卡牌RPG，角色扮演，輕鬆休閒，不肝不課，升級，戰力，逆襲，進化，養成，神器，掛機養成，多英雄對戰1750抽，免費送，預約就送，預約豪禮，預約好禮，抽獎，抽獎活動，無門檻福利遊戲，豪華獎勵，福利滿滿，開箱，無限開寶箱iPad Pro，LABUBU，Mycard點數卡，PS5，iPhone17 pro max，AirPods，超值大獎新武俠大明星，俠客傳説，暴走小蝦米, 吸血鬼幸存者, 鹹魚之王，一念逍遙，香腸三國，少年猛將傳，放置七騎士",
        description:
          "《人人有功練：腸仔江湖見》無厘頭武俠新解放置卡牌RPG 預約即送超癲1750抽，一起武林gogogo！還有傳說俠客免費拿！",
      },
    },
    // 广告投放营销预约页TT-Z渠道
    {
      path: "/pre/TT",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "《人人有功練：腸仔江湖見》預約即送1750抽！",
        keywords:
          "人人有功練，腸仔江湖見，預約，抽獎，事前登錄武俠，江湖，豪俠，俠客，奇俠，無厘頭武俠，搞笑江湖，香腸仔，爆笑RPG，無厘頭遊戲，搞怪遊戲放置遊戲，放置掛機，放置卡牌，卡牌養成，卡牌RPG，角色扮演，輕鬆休閒，不肝不課，升級，戰力，逆襲，進化，養成，神器，掛機養成，多英雄對戰1750抽，免費送，預約就送，預約豪禮，預約好禮，抽獎，抽獎活動，無門檻福利遊戲，豪華獎勵，福利滿滿，開箱，無限開寶箱iPad Pro，LABUBU，Mycard點數卡，PS5，iPhone17 pro max，AirPods，超值大獎新武俠大明星，俠客傳説，暴走小蝦米, 吸血鬼幸存者, 鹹魚之王，一念逍遙，香腸三國，少年猛將傳，放置七騎士",
        description:
          "《人人有功練：腸仔江湖見》無厘頭武俠新解放置卡牌RPG 預約即送超癲1750抽，一起武林gogogo！還有傳說俠客免費拿！",
      },
    },
    {
      path: "/pre/TT/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "《人人有功練：腸仔江湖見》預約即送1750抽！",
        keywords:
          "人人有功練，腸仔江湖見，預約，抽獎，事前登錄武俠，江湖，豪俠，俠客，奇俠，無厘頭武俠，搞笑江湖，香腸仔，爆笑RPG，無厘頭遊戲，搞怪遊戲放置遊戲，放置掛機，放置卡牌，卡牌養成，卡牌RPG，角色扮演，輕鬆休閒，不肝不課，升級，戰力，逆襲，進化，養成，神器，掛機養成，多英雄對戰1750抽，免費送，預約就送，預約豪禮，預約好禮，抽獎，抽獎活動，無門檻福利遊戲，豪華獎勵，福利滿滿，開箱，無限開寶箱iPad Pro，LABUBU，Mycard點數卡，PS5，iPhone17 pro max，AirPods，超值大獎新武俠大明星，俠客傳説，暴走小蝦米, 吸血鬼幸存者, 鹹魚之王，一念逍遙，香腸三國，少年猛將傳，放置七騎士",
        description:
          "《人人有功練：腸仔江湖見》無厘頭武俠新解放置卡牌RPG 預約即送超癲1750抽，一起武林gogogo！還有傳說俠客免費拿！",
      },
    },
    // 官网首页
    {
      path: "/home",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title: "《人人有功練：腸仔江湖見》下載即送1750抽！",
        keywords:
          "人人有功練，腸仔江湖見，下載，抽獎武俠，江湖，豪俠，俠客，奇俠，無厘頭武俠，搞笑江湖，香腸仔，爆笑RPG，無厘頭遊戲，搞怪遊戲放置遊戲，放置掛機，放置卡牌，卡牌養成，卡牌RPG，角色扮演，輕鬆休閒，不肝不課，升級，戰力，逆襲，進化，養成，神器，掛機養成，多英雄對戰1750抽，免費送，抽獎，抽獎活動，無門檻福利遊戲，豪華獎勵，福利滿滿，開箱，無限開寶箱iPad Pro，LABUBU，Mycard點數卡，PS5，iPhone17 pro max，AirPods，超值大獎新武俠大明星，俠客傳説，暴走小蝦米, 吸血鬼幸存者, 鹹魚之王，一念逍遙，香腸三國，少年猛將傳，放置七騎士",
        description:
          "《人人有功練：腸仔江湖見》無厘頭武俠新解放置卡牌RPG 下載即送超癲1750抽，一起武林gogogo！",
      },
      redirect: "/",
    },
    {
      path: "/home/m",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title: "《人人有功練：腸仔江湖見》下載即送1750抽！",
        keywords:
          "人人有功練，腸仔江湖見，下載，抽獎武俠，江湖，豪俠，俠客，奇俠，無厘頭武俠，搞笑江湖，香腸仔，爆笑RPG，無厘頭遊戲，搞怪遊戲放置遊戲，放置掛機，放置卡牌，卡牌養成，卡牌RPG，角色扮演，輕鬆休閒，不肝不課，升級，戰力，逆襲，進化，養成，神器，掛機養成，多英雄對戰1750抽，免費送，抽獎，抽獎活動，無門檻福利遊戲，豪華獎勵，福利滿滿，開箱，無限開寶箱iPad Pro，LABUBU，Mycard點數卡，PS5，iPhone17 pro max，AirPods，超值大獎新武俠大明星，俠客傳説，暴走小蝦米, 吸血鬼幸存者, 鹹魚之王，一念逍遙，香腸三國，少年猛將傳，放置七騎士",
        description:
          "《人人有功練：腸仔江湖見》無厘頭武俠新解放置卡牌RPG 下載即送超癲1750抽，一起武林gogogo！",
      },
      redirect: "/",
    },
    // 下载
    {
      path: "/down",
      meta: {
        title: "《人人有功練：腸仔江湖見》預約即送1750抽！",
        keywords:
          "人人有功練，腸仔江湖見，預約，抽獎，事前登錄武俠，江湖，豪俠，俠客，奇俠，無厘頭武俠，搞笑江湖，香腸仔，爆笑RPG，無厘頭遊戲，搞怪遊戲放置遊戲，放置掛機，放置卡牌，卡牌養成，卡牌RPG，角色扮演，輕鬆休閒，不肝不課，升級，戰力，逆襲，進化，養成，神器，掛機養成，多英雄對戰1750抽，免費送，預約就送，預約豪禮，預約好禮，抽獎，抽獎活動，無門檻福利遊戲，豪華獎勵，福利滿滿，開箱，無限開寶箱iPad Pro，LABUBU，Mycard點數卡，PS5，iPhone17 pro max，AirPods，超值大獎新武俠大明星，俠客傳説，暴走小蝦米, 吸血鬼幸存者, 鹹魚之王，一念逍遙，香腸三國，少年猛將傳，放置七騎士",
        description:
          "《人人有功練：腸仔江湖見》無厘頭武俠新解放置卡牌RPG 預約即送超癲1750抽，一起武林gogogo！還有傳說俠客免費拿！",
      },
      children: adRoutes,
    },
    // 404
    {
      path: "/:pathMatch(.*)*",
      component: () => import("../../components/404.vue"),
    },
    // 测试
    {
      path: "/test",
      component: () => import("./views/test.vue"),
    },
  ],
});
router.beforeEach((to, from, next) => {
  // 路由发生变化改变 description 和 keyword
  ReviseMeta(to.meta.title, to.meta.keywords, to.meta.description);

  // 定义特殊页面白名单，使用正则表达式匹配通配符
  const specialPages = [/^\/down(\/.*)?$/];

  // 检查当前路径是否在特殊页面白名单中
  const isSpecialPage = specialPages.some((pattern) => pattern.test(to.path));

  // 如果是特殊页面，直接调用 next()
  if (isSpecialPage) {
    next();
    return;
  }

  const isWap = deviceType() == "wap";

  // 定义PC端和移动端路径
  let pcPath = to.path.replace(/\/m$/, "");
  let wapPath = pcPath.endsWith("/") ? `${pcPath}m` : `${pcPath}/m`;

  // 根据设备类型跳转，避免重复添加或删除斜杠
  if (isWap && !to.path.endsWith("/m")) {
    next({ path: wapPath, query: to.query });
  } else if (!isWap && to.path.endsWith("/m")) {
    next({ path: pcPath, query: to.query });
  } else {
    next();
  }
});

export default router;
